import { createContext } from "react";

const alertasContext = createContext();

export default alertasContext;
